import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import LayoutLldd from '../components/LayoutLldd';
import HomeMenu from '../components/HomeMenu';
import Banner from '../components/Banner';
import HorizontalFormContact from '../components/HorizontalFormContact';

import '../assets/styles/components/Home.sass'; 

const Home = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/general-by-id/43`)
    .then(res => res.json())
    .then((res) => {
        setData(res);
      }
    )
  }, []);

  return(
    <LayoutLldd
      title={data.seo_title_es}
      description={data.seo_content_es}
    >
      <Banner/>
      <HorizontalFormContact />
      <HomeMenu />
      <div className="row contenido_min">
        { ReactHtmlParser(data.content_es) }
      </div>
    </LayoutLldd>
  )
}

export default Home;
